export const APP_SET_TOKEN = 'APP_SET_TOKEN';
export const APP_SET_GROUP = 'APP_SET_GROUP';
export const APP_SET_RESET_PASSWORD_REQUIRED = 'APP_SET_RESET_PASSWORD_REQUIRED';
export const APP_SET_RESET_PASSWORD_LINK = 'APP_SET_RESET_PASSWORD_LINK';
export const APP_SET_SEASON = 'APP_SET_SEASON';
export const APP_SET_SEASON_IDENTIFIER = 'APP_SET_SEASON_IDENTIFIER';
export const APP_SET_SEASON_YEAR = 'APP_SET_SEASON_YEAR';
export const APP_SET_EMPLOYEE_PERMISSIONS = 'APP_SET_EMPLOYEE_PERMISSIONS';
export const APP_SET_USER_EMAIL = 'APP_SET_USER_EMAIL';

export const APP_SET_OL_ORDER_FILTERS = 'APP_SET_OL_ORDER_FILTERS';
export const APP_SET_OL_ORDER_HIDDEN_COLUMNS = 'APP_SET_OL_ORDER_HIDDEN_COLUMNS';
export const APP_SET_OL_ORDER_SEARCH_FIELDS = 'APP_SET_OL_ORDER_SEARCH_FIELDS';
export const APP_SET_OL_ORDER_COLUMNS_WIDTH = 'APP_SET_OL_ORDER_COLUMNS_WIDTH';
export const APP_SET_OL_ORDER_COLUMNS_SEQUENCE = 'APP_SET_OL_ORDER_COLUMNS_SEQUENCE';


export const APP_SET_ZS_ORDER_FILTERS = 'APP_SET_ZS_ORDER_FILTERS';
export const APP_SET_ZS_ORDER_HIDDEN_COLUMNS = 'APP_SET_ZS_ORDER_HIDDEN_COLUMNS';
export const APP_SET_ZS_ORDER_SEARCH_FIELDS = 'APP_SET_ZS_ORDER_SEARCH_FIELDS';
export const APP_SET_ZS_ORDER_COLUMNS_WIDTH = 'APP_SET_ZS_ORDER_COLUMNS_WIDTH';
export const APP_SET_ZS_ORDER_COLUMNS_SEQUENCE = 'APP_SET_ZS_ORDER_COLUMNS_SEQUENCE';

export const APP_SET_PL_ORDER_FILTERS = 'APP_SET_PL_ORDER_FILTERS';
export const APP_SET_PL_ORDER_HIDDEN_COLUMNS = 'APP_SET_PL_ORDER_HIDDEN_COLUMNS';
export const APP_SET_PL_ORDER_SEARCH_FIELDS = 'APP_SET_PL_ORDER_SEARCH_FIELDS';
export const APP_SET_PL_ORDER_COLUMNS_WIDTH = 'APP_SET_PL_ORDER_COLUMNS_WIDTH';
export const APP_SET_PL_ORDER_COLUMNS_SEQUENCE = 'APP_SET_PL_ORDER_COLUMNS_SEQUENCE';

export const APP_SET_WR_ORDER_FILTERS = 'APP_SET_WR_ORDER_FILTERS';
export const APP_SET_WR_ORDER_HIDDEN_COLUMNS = 'APP_SET_WR_ORDER_HIDDEN_COLUMNS';
export const APP_SET_WR_ORDER_SEARCH_FIELDS = 'APP_SET_WR_ORDER_SEARCH_FIELDS';
export const APP_SET_WR_ORDER_COLUMNS_WIDTH = 'APP_SET_WR_ORDER_COLUMNS_WIDTH';
export const APP_SET_WR_ORDER_COLUMNS_SEQUENCE = 'APP_SET_WR_ORDER_COLUMNS_SEQUENCE';

export const APP_SET_EMPLOYEE_COLUMNS_WIDTH = 'APP_SET_EMPLOYEE_COLUMNS_WIDTH';
export const APP_SET_EMPLOYEE_COLUMNS_SEQUENCE = 'APP_SET_EMPLOYEE_COLUMNS_SEQUENCE';

export const APP_SET_EMPLOYEE_APPLICATION_COLUMNS_WIDTH = 'APP_SET_EMPLOYEE_APPLICATION_COLUMNS_WIDTH';
export const APP_SET_EMPLOYEE_APPLICATION_COLUMNS_SEQUENCE = 'APP_SET_EMPLOYEE_APPLICATION_COLUMNS_SEQUENCE';


export const APP_SET_PARTICIPANT_HIDDEN_COLUMNS = 'APP_SET_PARTICIPANT_HIDDEN_COLUMNS';
export const APP_SET_PARTICIPANT_FILTERS = 'APP_SET_PARTICIPANT_FILTERS';

export const APP_SET_PURCHASER_HIDDEN_COLUMNS = 'APP_SET_PURCHASER_HIDDEN_COLUMNS';
export const APP_SET_PURCHASER_FILTERS = 'APP_SET_PURCHASER_FILTERS';

export const APP_SET_ORDER = 'APP_SET_ORDER';
export const APP_UPDATE_ORDER = 'APP_UPDATE_ORDER';
export const APP_DELETE_ORDER = 'APP_DELETE_ORDER';

export const APP_SET_MODULE = 'APP_SET_MODULE';
export const APP_ALLOW_AUTO_ORDER_UPDATE = 'APP_ALLOW_AUTO_ORDER_UPDATE';
export const APP_SET_EMPLOYEE_ID = 'APP_SET_EMPLOYEE_ID';
export const APP_SET_EMPLOYEE_CONFIG_ID = 'APP_SET_EMPLOYEE_CONFIG_ID';
export const REACT_APP_VERSION = 'REACT_APP_VERSION';
export const APP_SET_EXTERNAL_ORDER_ID = 'APP_SET_EXTERNAL_ORDER_ID';

export const setReactAppVersion = version => ({
  type: REACT_APP_VERSION,
  payload: version
});

export const setToken = token => ({
  type: APP_SET_TOKEN,
  payload: token
});

export const setGroup = group => ({
  type: APP_SET_GROUP,
  payload: group
});

export const setResetPasswordRequired = resetPasswordRequired => ({
  type: APP_SET_RESET_PASSWORD_REQUIRED,
  payload: resetPasswordRequired
});
export const setResetPasswordLink = resetPasswordLink => ({
  type: APP_SET_RESET_PASSWORD_LINK,
  payload: resetPasswordLink
});

export const setSeason = season => ({
  type: APP_SET_SEASON,
  payload: season
});

export const setSeasonIdentifier = seasonIdentifier => ({
  type: APP_SET_SEASON_IDENTIFIER,
  payload: seasonIdentifier
});

export const setSeasonYear = seasonYear => ({
  type: APP_SET_SEASON_YEAR,
  payload: seasonYear
});

export const setEmployeePermissions = permissions => ({
  type: APP_SET_EMPLOYEE_PERMISSIONS,
  payload: permissions
});

export const setUserEmail = email => ({
  type: APP_SET_USER_EMAIL,
  payload: email
});

export const setParticipantFilters = participantFilters => ({
  type: APP_SET_PARTICIPANT_FILTERS,
  payload: participantFilters
});

export const setParticipantHiddenColumns = participantHiddenColumns => ({
  type: APP_SET_PARTICIPANT_HIDDEN_COLUMNS,
  payload: participantHiddenColumns
});

export const setPurchaserFilters = purchaserFilters => ({
  type: APP_SET_PURCHASER_FILTERS,
  payload: purchaserFilters
});

export const setPurchaserHiddenColumns = purchaserHiddenColumns => ({
  type: APP_SET_PURCHASER_HIDDEN_COLUMNS,
  payload: purchaserHiddenColumns
});

export const setOrder = order => ({
  type: APP_SET_ORDER,
  payload: order
});

export const updateOrder = order => ({
  type: APP_UPDATE_ORDER,
  payload: order
});

export const deleteOrder = orderId => ({
  type: APP_DELETE_ORDER,
  payload: orderId
});

export const setModule = module => ({
  type: APP_SET_MODULE,
  payload: module
});

export const setAllowAutoOrderUpdate = value => ({
  type: APP_ALLOW_AUTO_ORDER_UPDATE,
  payload: value
});

export const setEmployeeId = employeeId => ({
  type: APP_SET_EMPLOYEE_ID,
  payload: employeeId
});

export const setEmployeeConfigId = employeeConfigId => ({
  type: APP_SET_EMPLOYEE_CONFIG_ID,
  payload: employeeConfigId
});

export const setOLOrderFilters = olOrderFilters => ({
  type: APP_SET_OL_ORDER_FILTERS,
  payload: olOrderFilters
});

export const setOLOrderHiddenColumns = olOrderHiddenColumns => ({
  type: APP_SET_OL_ORDER_HIDDEN_COLUMNS,
  payload: olOrderHiddenColumns
});

export const setOLOrderSearchFields = olOrderSearchFields => ({
  type: APP_SET_OL_ORDER_SEARCH_FIELDS,
  payload: olOrderSearchFields
});

export const setOLOrderColumnsWidth = olOrderColumnsWidth => ({
  type: APP_SET_OL_ORDER_COLUMNS_WIDTH,
  payload: olOrderColumnsWidth
});

export const setOLOrderColumnsSequence = olOrderColumnsSequence => ({
  type: APP_SET_OL_ORDER_COLUMNS_SEQUENCE,
  payload: olOrderColumnsSequence
});


export const setZSOrderFilters = zsOrderFilters => ({
  type: APP_SET_ZS_ORDER_FILTERS,
  payload: zsOrderFilters
});

export const setZSOrderHiddenColumns = zsOrderHiddenColumns => ({
  type: APP_SET_ZS_ORDER_HIDDEN_COLUMNS,
  payload: zsOrderHiddenColumns
});

export const setZSOrderSearchFields = zsOrderSearchFields => ({
  type: APP_SET_ZS_ORDER_SEARCH_FIELDS,
  payload: zsOrderSearchFields
});

export const setZSOrderColumnsWidth = zsOrderColumnsWidth => ({
  type: APP_SET_ZS_ORDER_COLUMNS_WIDTH,
  payload: zsOrderColumnsWidth
});

export const setZSOrderColumnsSequence = zsOrderColumnsSequence => ({
  type: APP_SET_ZS_ORDER_COLUMNS_SEQUENCE,
  payload: zsOrderColumnsSequence
});


export const setPLOrderFilters = plOrderFilters => ({
  type: APP_SET_PL_ORDER_FILTERS,
  payload: plOrderFilters
});

export const setPLOrderHiddenColumns = plOrderHiddenColumns => ({
  type: APP_SET_PL_ORDER_HIDDEN_COLUMNS,
  payload: plOrderHiddenColumns
});

export const setPLOrderSearchFields = plOrderSearchFields => ({
  type: APP_SET_PL_ORDER_SEARCH_FIELDS,
  payload: plOrderSearchFields
});

export const setPLOrderColumnsWidth = plOrderColumnsWidth => ({
  type: APP_SET_PL_ORDER_COLUMNS_WIDTH,
  payload: plOrderColumnsWidth
});

export const setPLOrderColumnsSequence = plOrderColumnsSequence => ({
  type: APP_SET_PL_ORDER_COLUMNS_SEQUENCE,
  payload: plOrderColumnsSequence
});

export const setWROrderFilters = wrOrderFilters => ({
  type: APP_SET_WR_ORDER_FILTERS,
  payload: wrOrderFilters
});

export const setWROrderHiddenColumns = wrOrderHiddenColumns => ({
  type: APP_SET_WR_ORDER_HIDDEN_COLUMNS,
  payload: wrOrderHiddenColumns
});

export const setWROrderSearchFields = wrOrderSearchFields => ({
  type: APP_SET_WR_ORDER_SEARCH_FIELDS,
  payload: wrOrderSearchFields
});

export const setWROrderColumnsWidth = wrOrderColumnsWidth => ({
  type: APP_SET_WR_ORDER_COLUMNS_WIDTH,
  payload: wrOrderColumnsWidth
});

export const setWROrderColumnsSequence = wrOrderColumnsSequence => ({
  type: APP_SET_WR_ORDER_COLUMNS_SEQUENCE,
  payload: wrOrderColumnsSequence
});

export const setEOrderColumnsWidth = eColumnsWidth => ({
  type: APP_SET_EMPLOYEE_COLUMNS_WIDTH,
  payload: eColumnsWidth
});

export const setEOrderColumnsSequence = eColumnsSequence => ({
  type: APP_SET_EMPLOYEE_COLUMNS_SEQUENCE,
  payload: eColumnsSequence
});

export const setEAOrderColumnsWidth = eaColumnsWidth => ({
  type: APP_SET_EMPLOYEE_APPLICATION_COLUMNS_WIDTH,
  payload: eaColumnsWidth
});

export const setEAOrderColumnsSequence = eaColumnsSequence => ({
  type: APP_SET_EMPLOYEE_APPLICATION_COLUMNS_SEQUENCE,
  payload: eaColumnsSequence
});

export const setExternalOrderId = id => ({
  type: APP_SET_EXTERNAL_ORDER_ID,
  payload: id
});
